import React from 'react';
import Header from './Header.jsx';
import Footer from './Footer.jsx';
import { useSelector } from 'react-redux';
import BaseError from '../misc/BaseError.jsx';
import { twMerge } from 'tailwind-merge';
import TicketForm from '../../components/misc/tickets/TicketForm.jsx';
import { PERMISSION_TICKETS_USER } from '../../utils/constants.js';
import useCurrentUser from '../../hooks/useCurrentUser.js';
import { useLocation } from 'react-router-dom';

const AuthLayout = ({
    children,
    title,
    goBack,
    backRoute,
    forwardRoute,
    forwardIcon,
    forwardPermission,
    forwardPermissionAttribute,
    forwardIconClassName,
    mainClassNames
}) => {
    const error = useSelector((state) => state.error);
    const { permissions: userPermissions } = useCurrentUser();

    const { pathname } = useLocation();

    const noFooterPaths = ['/personal-assistant'];
    const noTicketPaths = ['/personal-assistant'];

    const hideFooter = noFooterPaths.some((prefix) => pathname.startsWith(prefix));
    const hideTicket = noTicketPaths.some((prefix) => pathname.startsWith(prefix));

    return (
        <div className='min-h-screen flex flex-col relative'>
            <Header
                title={title}
                goBack={goBack}
                backRoute={backRoute}
                {...(!error.status && {
                    forwardRoute,
                    forwardIcon,
                    forwardPermission,
                    forwardPermissionAttribute,
                    forwardIconClassName
                })}
            />
            <main className={twMerge('flex-grow pt-[7.5rem]', mainClassNames, error.status ? 'content-center' : '')}>
                {error.status && <BaseError error={error} statusText={error.statusText} status={error.status} />}
                {!error.status && children}
                {!hideTicket && !!userPermissions[PERMISSION_TICKETS_USER]?.create && <TicketForm />}
            </main>
            {!hideFooter && <Footer />}
        </div>
    );
};

export default AuthLayout;
